import { render, staticRenderFns } from "./addTeamBuild.vue?vue&type=template&id=dd8f1c66&scoped=true"
import script from "./addTeamBuild.vue?vue&type=script&lang=js"
export * from "./addTeamBuild.vue?vue&type=script&lang=js"
import style0 from "./addTeamBuild.vue?vue&type=style&index=0&id=dd8f1c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8f1c66",
  null
  
)

export default component.exports